export enum DeviceTokenType {
  IOS = 'IOS',
  ANDROID = 'ANDROID',
}

export enum DeviceTokenApplicationType {
  STUDENT = 'STUDENT',
  WRITER = 'WRITER',
}
